import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImportsModule } from '../../../shared/imports.module';
import { Beneficiario, Usuario } from '../../../shared/models';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BeneficiariosService } from '../../../shared/services/beneficiarios.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { saveAs } from 'file-saver';
import { PerfilStore } from '../../../shared/store/perfil.store';

interface Archivo {
  nombre: string;
  tipo: 'pdf' | 'xml' | 'jpg' | 'png';
  url?: string;
}

@Component({
  selector: 'app-beneficiarios-detalles',
  standalone: true,
  imports: [CommonModule, FormsModule, ImportsModule, NzSpinModule],
  templateUrl: './beneficiarios-detalles.component.html',
  styleUrl: './beneficiarios-detalles.component.scss'
})
export class BeneficiariosDetallesComponent implements OnInit {
  @Input() beneficiario?: Beneficiario;
  
  observaciones: string = '';
  procesando: boolean = false;
  archivos: Archivo[] = [];
  fechaFinalizacion: Date | null = null;
  loading : boolean = false;
  isConfirmLoading : boolean = false;
  isVisible : boolean = false;
  user ?: Usuario | null = null;
  $onDestroy: Subject<void> = new Subject<void>();
  CaracterEspecial : string = '||;'
  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  constructor(private message: NzMessageService, private beneficiariosService: BeneficiariosService, private cdr: ChangeDetectorRef, private drawerRef: NzDrawerRef, private sessionStore: PerfilStore) {}

  ngOnInit() {
    this.getUser();
  }

  getUser(){
    this.sessionStore.getPerfil()
    .pipe(takeUntil(this.$onDestroy))
    .subscribe((user) => {
      this.user = user;
    });
  }
  

  getArchivoIcon(tipo: string): string {
    switch (tipo) {
      case 'pdf':
        return 'assets/images/pdf.png';
      case 'xml':
        return 'assets/images/xml.png';
      case 'jpg':
      case 'png':
        return 'assets/images/image.png';
      default:
        return 'assets/images/file.png';
    }
  }

  verArchivo(archivo: Archivo) {
    this.message.info(`Descargando archivo: ${archivo.nombre}`);
    this.loading = true;
    this.beneficiariosService.descargarArchivos(this.beneficiario?.id!,archivo.nombre)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (blob) => {
          const nombreArchivo = `${archivo.nombre}`;            
          saveAs(blob, nombreArchivo);
          this.message.success(`Archivo ${archivo.nombre} descargado correctamente`);
        },
        error: (error) => {
          console.error('Error al descargar archivo:', error);
          this.message.error('Error al descargar el archivo. Intente nuevamente.');
        }
      });
  }

  actualizarSolicitud(id?: number, esAprobada?: boolean) {
    return this.beneficiariosService.actualizarSolicitud({ Id: id, EsAprobada: esAprobada });
  }

  aprobarSolicitud() {
    this.procesando = true;
    this.actualizarSolicitud(this.beneficiario?.id!, true)
    .pipe(
      finalize(() => {
        this.procesando = false;
        this.cdr.detectChanges();
      }
    ))
    .subscribe({
      next: (data) => {
        this.message.success('Beneficiario aprobado correctamente');
        this.drawerRef.close();
      },
      error: (error) => {
        this.message.error('Error al aprobar el beneficiario. Intente nuevamente.');
        console.error('Error al aprobar beneficiario:', error);
      }
    });
  }

  rechazarSolicitud() {
    this.procesando = true;
    this.actualizarSolicitud(this.beneficiario?.id!, false)
    .pipe(
      finalize(() => {
        this.procesando = false;
        this.cdr.detectChanges();
      }
    ))
    .subscribe({
      next: (data) => {
        this.message.success('Beneficiario rechazado correctamente');
        this.drawerRef.close();
      },
      error: (error) => {
        this.message.error('Error al aprobar el beneficiario. Intente nuevamente.');
        console.error('Error al aprobar beneficiario:', error);
      }
    });
  }


  confirmarBajaBeneficiario() {
        if (!this.fechaFinalizacion) {
          this.message.warning('Debe seleccionar una fecha de finalización');
          return;
        }
  
        const fechaFormateada = this.fechaFinalizacion.toISOString().split('T')[0];
        
        const objetoActualizacion = {
          Id: this.beneficiario!.id,
          EsInterrumpida: true,
          FechaFin: fechaFormateada
        };
        this.loading = true;
        
        this.beneficiariosService.actualizarSolicitud(objetoActualizacion)
          .pipe(
            finalize(() => {
              this.loading = false;
              this.cdr.detectChanges();
            })
          )
          .subscribe({
            next: (response) => {
              this.message.success(`Beneficiario ${this.beneficiario!.beneficiarioNombre} dado de baja correctamente`);
              this.isVisible = false;
              this.drawerRef.close();
            },
            error: (error) => {
              console.error('Error al dar de baja el beneficiario:', error);
              this.message.error('Error al dar de baja el beneficiario. Intente nuevamente.');
            }
          });
    }

    mostrarModal() {
      this.isVisible = true;
    }

    Cancel() {
      this.isVisible = false;
      this.fechaFinalizacion = null;
    }

    getColor( estatus: string){
    let res = "default";
    switch (estatus) {
      case 'Gestación en curso':
        res = 'green';
        break;
      case 'Gestación interrumpida':
        res = 'red';
        break;
      case 'Gestación finalizada':
        res = 'blue';
        break;
      case 'Solicitud en espera de aprobacion':
        res = 'yellow';
        break;
      default:
        res = 'default';
      break;


    }
    return res;
  }

    getarchivos( archivosStr: string | null | undefined ): Archivo[] {
      if (!archivosStr) return [];
      return archivosStr.split(this.CaracterEspecial).map(nombre => {
        const extension = nombre.split('.').pop()?.toLowerCase();
        let tipo: 'pdf' | 'xml' | 'jpg' | 'png' = 'pdf';
        if (extension === 'xml') tipo = 'xml';
        else if (extension === 'jpg' || extension === 'jpeg') tipo = 'jpg';
        else if (extension === 'png') tipo = 'png';
        return { nombre, tipo };
      });
    }

  disabledDate = (current: Date): boolean => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(23, 59, 59, 999);
    return current && current.getTime() > yesterday.getTime();
  };

}
